export const FREQUENCIES = [
  { value: "daily", label: "Daily", hint: "Every selected weekday" },
  { value: "weekly", label: "Weekly", hint: "Chosen weekdays, every week" },
  { value: "fortnightly", label: "Fortnightly", hint: "Chosen weekdays, every other week" },
  { value: "monthly", label: "Monthly", hint: "Same day each month" },
  { value: "adhoc", label: "Ad-hoc", hint: "Dates booked as needed" },
];
export const WEEKDAYS = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];
export const CONTRACT_STATUS = {
  active: { label: "Active", cls: "bg-emerald-100 text-emerald-800 dark:bg-emerald-900/40 dark:text-emerald-300" },
  paused: { label: "Paused", cls: "bg-amber-100 text-amber-800 dark:bg-amber-900/40 dark:text-amber-300" },
  ended: { label: "Ended", cls: "bg-slate-200 text-slate-700 dark:bg-slate-800 dark:text-slate-300" },
};
export const VISIT_STATUS = {
  scheduled: { label: "Scheduled", cls: "bg-blue-100 text-blue-800 dark:bg-blue-900/40 dark:text-blue-300", dot: "#1d4ed8" },
  in_progress: { label: "On site", cls: "bg-orange-100 text-orange-800 dark:bg-orange-900/40 dark:text-orange-300", dot: "#ea580c" },
  completed: { label: "Completed", cls: "bg-emerald-100 text-emerald-800 dark:bg-emerald-900/40 dark:text-emerald-300", dot: "#10b981" },
  cancelled: { label: "Cancelled", cls: "bg-slate-100 text-slate-500 line-through dark:bg-slate-800 dark:text-slate-400", dot: "#94a3b8" },
};
export const BOOKED_BY = { schedule: "Schedule", admin: "Office", client: "Client" };

export const pad = (n) => String(n).padStart(2, "0");
export const iso = (d) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
export const todayIso = () => iso(new Date());
export const addDays = (isoStr, n) => { const d = new Date(`${isoStr}T00:00:00`); d.setDate(d.getDate() + n); return iso(d); };
export const daysBetween = (a, b) => Math.round((new Date(`${b}T00:00:00`) - new Date(`${a}T00:00:00`)) / 86400000);
export const fmtDay = (isoStr, opts) => isoStr ? new Date(`${isoStr}T00:00:00`).toLocaleDateString("en-GB", opts || { weekday: "short", day: "numeric", month: "short", year: "numeric" }) : "—";
export const monthLabel = (cursor) => cursor.toLocaleDateString("en-GB", { month: "long", year: "numeric" });

/** 42-cell Monday-first grid around the month in `cursor`; returns { days: Date[], start, end } (ISO). */
export const monthGrid = (cursor) => {
  const start = new Date(cursor.getFullYear(), cursor.getMonth(), 1);
  start.setDate(1 - ((start.getDay() + 6) % 7));
  const days = Array.from({ length: 42 }, (_, i) => { const d = new Date(start); d.setDate(start.getDate() + i); return d; });
  return { days, start: iso(days[0]), end: iso(days[41]) };
};

export const groupByDate = (visits) => visits.reduce((m, v) => { const k = v.visit_date || v.date; (m[k] = m[k] || []).push(v); return m; }, {});
export const RATE_BASES = [["visit", "per visit"], ["hour", "per hour"], ["day", "per day"]];
export const BASIS_UNIT = { visit: "visit", hour: "hr", day: "day" };
export const rateText = (c) => c?.rate ? `${fmtMoney(c.rate)} / ${BASIS_UNIT[c.rate_basis] || "visit"}${(c.operatives_per_visit || c.operatives) > 1 ? ` × ${c.operatives_per_visit || c.operatives} ops` : ""}` : "no rate set";
export const lineTotal = (rate, basis, ops, units) => Math.round(Number(rate || 0) * (basis === "hour" || basis === "day" ? Number(units || 0) * Math.max(1, Number(ops || 1)) : 1) * 100) / 100;
export const fmtMoney = (n) => `£${Number(n || 0).toLocaleString("en-GB", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
